import { Injectable } from '@angular/core';
import {
    HttpInterceptor,
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpErrorResponse,
} from '@angular/common/http';

import { Observable, lastValueFrom, from } from 'rxjs';
import { UserService } from '../services/user.service';

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {

    constructor(private userService: UserService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return from(this.myHandle(request, next))
    }

    async myHandle(request: HttpRequest<any>, next: HttpHandler) {
        const token: string | null = this.userService.token;
        let timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        // timeZone can be undefined on some browsers/OS setups: setHeaders would throw, backend has a default
        if(request && timezone){
            request = request.clone({
                setHeaders: {
                'X-Timezone': timezone,
                },
            });
        }

        if (token) {
            if (this.userService.isExpiredToken) {
                console.warn("Auth token is expired");
                this.userService.logout(true);
                throw new HttpErrorResponse({
                    error: 'token_expired',
                    status: 401,
                    statusText: 'ERROR - token expired'
                });
            }
            request = request.clone({ headers: request.headers.set('Authorization', 'Bearer ' + token) });
        } else {
            console.warn("Auth token is missing")
        }

        return lastValueFrom(next.handle(request));
    }
}